import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import FingoLoader from '../../assets/gifs/fingo-loader.gif';

const Spinner = () => (
  <Container
    variant="primary"
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      justifySelf: 'center',
    }}
  >
    <Box
      component="img"
      src={FingoLoader}
      alt="Loading..."
      sx={{
        maxWidth: '400px',
        width: '100%',
        height: 'auto',
      }}
    />
  </Container>
);

export default Spinner;
